
import { IShopFormField } from '@/common/interface/shop';
import { ECarShopField } from '@/common/enum/carShop';
import { Vue, Component, Emit, Prop, Watch, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';

import AddressField from '@/views/shop/components/shopFieldTemplate/AddressField.vue';
import AdvertiserMobilePhoneNumberField from '@/views/shop/components/shopFieldTemplate/AdvertiserMobilePhoneNumberField.vue';
import BossIdImageField from '@/views/shop/components/shopFieldTemplate/BossIdImageField.vue';
import DataChedField from '@/views/shop/components/shopFieldTemplate/DataChedField.vue';
import MainBusinessField from '@/views/shop/components/shopFieldTemplate/MainBusinessField.vue';
import ManagerTelsField from '@/views/shop/components/shopFieldTemplate/ManagerTelsField.vue';
import NameField from '@/views/shop/components/shopFieldTemplate/NameField.vue';
import ParkNumField from '@/views/shop/components/shopFieldTemplate/ParkNumField.vue';
import RestAreaField from '@/views/shop/components/shopFieldTemplate/RestAreaField.vue';
import ShopImagesField from '@/views/shop/components/shopFieldTemplate/ShopImagesField.vue';
import StationField from '@/views/shop/components/shopFieldTemplate/StationField.vue';
import ShopLicenseField from '@/views/shop/components/shopFieldTemplate/ShoplicenseField.vue';
import ShopVideosField from '@/views/shop/components/shopFieldTemplate/ShopVideosField.vue';
import StartTimeField from '@/views/shop/components/shopFieldTemplate/StartTimeField.vue';
import StartTimeYueField from '@/views/shop/components/shopFieldTemplate/StartTimeYueField.vue';
import TelsField from '@/views/shop/components/shopFieldTemplate/TelsField.vue';
import PreTelsField from '@/views/shop/components/shopFieldTemplate/PreTelsField.vue';
import VideosField from '@/views/shop/components/shopFieldTemplate/VideosField.vue';
import BusinessTimeField from '@/views/shop/components/shopFieldTemplate/BusinessTimeField.vue';
import StaffField from './field/StaffField.vue';
import OnSiteService from '@/views/shop/components/shopFieldTemplate/OnSiteService.vue';
import IdentityNumField from '@/views/shop/components/shopFieldTemplate/IdentityNumField.vue';
import ShopImagesOtherField from '@/views/shop/components/shopFieldTemplate/ShopImagesOtherField.vue';
import MarketField from '@/views/shop/components/shopFieldTemplate/MarketField.vue';
import ShopCarImagesField from './field/ShopCarImagesField.vue';

import lazyInject from '@/di';
import ShopService from '@/services/shop.service';

@Component({
  components: {
    AddressField,
    AdvertiserMobilePhoneNumberField,
    BossIdImageField,
    BusinessTimeField,
    DataChedField,
    MainBusinessField,
    ManagerTelsField,
    NameField,
    ParkNumField,
    RestAreaField,
    ShopImagesField,
    ShopLicenseField,
    ShopVideosField,
    StartTimeField,
    StationField,
    TelsField,
    VideosField,
    StartTimeYueField,
    OnSiteService,
    IdentityNumField,
    ShopCarImagesField,
    ShopImagesOtherField,
  },
})
export default class CarShopEditor extends Vue {
  isVisible = false;

  title = '';

  ECarShopField = ECarShopField;

  field: IShopFormField | null = null;

  @lazyInject(ShopService)
  shopService!: ShopService;

  @Prop()
  encryptTels!: string;

  submittable = false;

  adUserPhone = '';

  adUserBind = false;

  get rules() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rules: any = {};
    if (!this.field || this.field == null) {
      return rules;
    }
    if (!this.field.rule) {
      return rules;
    }

    rules.value = this.field.rule;
    return rules;
  }

  @Prop({
    default: () => {
      return '';
    },
  })
  shopId!: string;

  @Prop()
  editingField!: IShopFormField;

  @Prop()
  poi!: string;

  @Ref()
  readonly ruleForm!: FormModel;

  @Watch('editingField', { deep: true })
  watchEditingField() {
    if (this.editingField == null) {
      return;
    }
    this.title = this.editingField.fieldTitle;
    this.field = { ...this.editingField };
  }

  @Emit('submit')
  onConfirm() {
    return { [`${this.field?.label}`]: this.field?.value };
  }

  getComponent(type: string) {
    switch (type) {
      case ECarShopField.NAME: {
        return NameField;
      }
      case ECarShopField.ADDRESS: {
        return AddressField;
      }
      case ECarShopField.MANAGER_ID: {
        return BossIdImageField;
      }
      case ECarShopField.BUSINESS_TIME: {
        return BusinessTimeField;
      }
      // case ECarShopField.MANAGER_TELS: {
      //   return ManagerTelsField;
      // }
      case ECarShopField.ADVERTISER_MOBILE_PHONE_NUMBER: {
        return AdvertiserMobilePhoneNumberField;
      }
      case ECarShopField.START_TIME: {
        return StartTimeYueField;
      }
      // case ECarShopField.MAIN_BUSINESS: {
      //   return MainBusinessField;
      // }
      case ECarShopField.MERCHANT_TELEPHONE: {
        return TelsField;
      }
      case ECarShopField.TELS: {
        return PreTelsField;
      }
      // case ECarShopField.DATA_CHED: {
      //   return DataChedField;
      // }
      // case ECarShopField.STAFF: {
      //   return StaffField;
      // }
      // case ECarShopField.STATION: {
      //   return StationField;
      // }
      // case ECarShopField.PARK_NUM: {
      //   return ParkNumField;
      // }
      case ECarShopField.MARKET_NAME: {
        return MarketField;
      }
      case ECarShopField.SHOP_USER_RELATIONS: {
        return StaffField;
      }
      case ECarShopField.JOIN_VIDEOS: {
        return VideosField;
      }
      case ECarShopField.SHOP_LICENSE: {
        return ShopLicenseField;
      }
      case ECarShopField.COVER_PICS: {
        return ShopLicenseField;
      }
      case ECarShopField.HEAD_PICS: {
        return ShopLicenseField;
      }
      case ECarShopField.PICS: {
        return ShopCarImagesField;
      }
      case ECarShopField.OTHER_QUALIFICATIONS: {
        return ShopImagesOtherField;
      }
      case ECarShopField.IDENTITY_NUM: {
        return IdentityNumField;
      }
      default:
        break;
    }
  }
  async shopBk() {
    const { id } = this.$route.params;
    const res = await this.shopService.adUserBk(id);
    this.adUserPhone = res?.ad_user_phone || '';
    this.adUserBind = res?.bind || false;
  }
  handleForceRefresh() {
    this.$emit('refresh');
  }

  close() {
    this.isVisible = false;
    this.field = null;
  }

  open() {
    this.isVisible = true;
    // if (this.field?.label === ECarShopField.ADVERTISER_MOBILE_PHONE_NUMBER) {
    //   this.shopBk();
    // }
  }

  handleSubmittable(submittable: boolean) {
    this.submittable = submittable;
  }

  mounted() {
    this.watchEditingField();
  }
}
